<template>
  <a-table :pagination='false' :loading='listLoading' :rowKey='keyRow'  :columns='columns' :data-source='data' bordered>
    <template v-slot:exchange_name="{ record }">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.exchange_image)" alt="" style="width:50px;height:50px">
        </template>
        <template #description>
          <p class="s_omit2">{{record.exchange_name}}</p>
        </template>
      </a-card-meta>
    </template>
    <template v-slot:point="{ record }">{{record.point}}积分</template>
    <!-- 新 -->
    <template v-slot:member_gift="{ record }">
            <div class="ds-i-b m-r-15" v-for="(item,index) in record.goods" :key="index">
                <img :src="item.image_url?info.picdomain+'/'+item.image_url:'@/assets/images/normal.png'" style="width:70px;height:70px;border-radius:5px"/>
            </div>
            <a href="javaScript:;" class="s_c376" @click="seeMemberInfo(record)">查看</a>
    </template>
  </a-table>
  
  <a-modal :keyboard="false" title="核销礼品" v-model:visible="showGift" centered :width='1000' :footer="null" destroyOnClose>
     <a-table :pagination='false' rowKey='id' bordered :columns='giftColumns' :data-source='list'>
        <template v-slot:goods="{ record }">
            <div class="s_flex_ali">
              <div class="ds-i-b m-r-15">
                <img :src="record.image_url?info.picdomain+'/'+record.image_url:'@/assets/images/normal.png'" style="width:70px;height:70px;border-radius:5px"/>
              </div>
              <span class="m-l-10">{{record.goods_name}}</span>
            </div>
        </template>
     </a-table>
  </a-modal>
</template>
<script>
import { ref,reactive, toRefs } from "vue";
import store from "@/store";
export default {
  props:{
    listLoading:Boolean,
    columns:Array,
    data:Array,
    keyRow:String
  },
  setup(props) {
    const state = reactive({
      showGift:false,
      list:[],
      giftColumns:[
          {
            title: "礼品名称",
            dataIndex: "goods_name",
            key: "goods_name",
             slots: { customRender: "goods" },
          },
          {
            title: "规格",
            dataIndex: "sku_sn_name",
            key: "sku_sn_name",
          },
          {
            title: "数量",
            dataIndex: "number",
            key: "number",
          },
      ]
    })
    const seeMemberInfo = function(record){
          state.list = record.goods || [];

          state.showGift = true;
    }
    return{
      info: ref(store.state.user.info),
      seeMemberInfo,
      ...toRefs(state)
    }
  }
  
}
</script>